import SSONavigationContent from "pages/sso/SSONavigationContent";
import React, { useEffect } from "react";
import { t } from "i18next";
import { LINK } from 'utils/constants/Constants';

const CommissionStatement = () => {
  
  useEffect(() => {
    document.title = t('pageTitleADA.commissionStatement');
  }, []);

  return (
    <SSONavigationContent
      header={t("sso.header.commissions")}
      ssoUrl={LINK.SHP_R2W_SSO_LINK}
      dataTestId="ssoLinkCommissionStatement"
      targetName="CommissionStatement"
    />
  );
};
export default CommissionStatement;
